var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneralSign({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13.125C10.6066 13.125 13.125 10.6066 13.125 7.5C13.125 4.3934 10.6066 1.875 7.5 1.875C4.3934 1.875 1.875 4.3934 1.875 7.5C1.875 10.6066 4.3934 13.125 7.5 13.125Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.5H8.75C8.83288 7.5 8.91237 7.53292 8.97097 7.59153C9.02958 7.65013 9.0625 7.72962 9.0625 7.8125V9.6875C9.0625 9.77038 9.02958 9.84987 8.97097 9.90847C8.91237 9.96708 8.83288 10 8.75 10H6.875C6.62636 10 6.3879 9.90123 6.21209 9.72541C6.03627 9.5496 5.9375 9.31114 5.9375 9.0625V5.9375C5.9375 5.68886 6.03627 5.4504 6.21209 5.27459C6.3879 5.09877 6.62636 5 6.875 5H8.125C8.37364 5 8.6121 5.09877 8.78791 5.27459C8.96373 5.4504 9.0625 5.68886 9.0625 5.9375",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralSign);
export default __webpack_public_path__ + "static/media/generalSign.93ef50a49a40f7aacd9901ff518fc477.svg";
export { ForwardRef as ReactComponent };